import { render, staticRenderFns } from "./GPFUPCropper.vue?vue&type=template&id=3ca1549c&"
import script from "./GPFUPCropper.vue?vue&type=script&lang=ts&"
export * from "./GPFUPCropper.vue?vue&type=script&lang=ts&"
import style0 from "./GPFUPCropper.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports